// extracted by mini-css-extract-plugin
module.exports = {"canvas":"_1Q-MFq4N","site":"JpZyEd_T"};